<form novalidate id="achPay" #achPayForm="ngForm">
  <div class="flex flex-col gap-5">
    <div class="flex items-end gap-3">
      <div class="flex-grow-1 select-field w-full">
        <label class="required">Billing Address</label>
        <select
          required
          name="Address"
          [disabled]="isProcessing"
          [ngModel]="addressId"
          [class.invalid]="Address.invalid && isSubmitted && !addressId"
          (ngModelChange)="onAddressSelected($event)"
          #Address="ngModel"
        >
          <ng-container *ngFor="let address of customerAddresses">
            <option [ngValue]="address.Id">
              {{ getFullAddress(address) }}
            </option>
          </ng-container>
        </select>
      </div>

      <button
        cjButton
        type="button"
        class="!bg-blue-10 !text-blue-90 !border-blue-10"
        [disabled]="isProcessing"
        (click)="onAddressAdd.emit()"
      >
        <cj-icon icon="plus" pack="font-awesome-solid"></cj-icon>
        Add address
      </button>
    </div>

    <ng-container *ngIf="!isInitializing">
      <ng-container *ngIf="!isAddACH">
        <div
          *ngIf="
            customerACHDetails && customerACHDetails.length;
            else emptyACHDetails
          "
        >
          <label class="font-medium mb-2">Select ACH</label>
          <cj-radio-group
            class="ach-list"
            name="CustomerACH"
            [ngModel]="selectedACH?.paymentIdentifier"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onSelectACH($event)"
          >
            <cj-radio
              *ngFor="let ach of customerACHDetails; let i = index"
              class="ach-item"
              [class.selected]="
                selectedACH?.paymentIdentifier === ach.paymentIdentifier
              "
              [value]="ach.paymentIdentifier"
            >
              <span>****{{ ach.account4Digits }}</span>
              <span>{{ ach.accountType === 0 ? "Checking" : "Savings" }}</span>
            </cj-radio>
          </cj-radio-group>
        </div>
        <ng-template #emptyACHDetails>
          <div class="ach-none flex flex-col items-center justify-center p-4">
            <span class="font-italic font-medium text-gray-60"
              >Customer have no ACH saved</span
            >
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
    <div class="flex items-center gap-3" *ngIf="isAddACH">
      <cj-form-field class="flex-grow-1">
        <cj-form-label>Account Number</cj-form-label>
        <input
          cjInput
          fullWidth
          required
          type="text"
          name="AccountNumber"
          placeholder="**** **** **** ****"
          [disabled]="isProcessing"
          [status]="AccountNumber.invalid && isSubmitted ? 'danger' : ''"
          [ngModel]="achPayment.AccountNumber"
          (ngModelChange)="onChange('AccountNumber', $event)"
          #AccountNumber="ngModel"
        />
      </cj-form-field>
      <cj-form-field class="flex-grow-1">
        <cj-form-label>Routing Number</cj-form-label>
        <input
          cjInput
          fullWidth
          required
          type="text"
          name="RoutingNumber"
          placeholder="**** **** **** ****"
          [disabled]="isProcessing"
          [status]="RoutingNumber.invalid && isSubmitted ? 'danger' : ''"
          [ngModel]="achPayment.RoutingNumber"
          (ngModelChange)="onChange('RoutingNumber', $event)"
          #RoutingNumber="ngModel"
        />
      </cj-form-field>
    </div>

    <div class="flex items-center gap-3" *ngIf="isAddACH">
      <div class="flex-grow-1 select-field w-full">
        <label>Account Type</label>
        <select
          name="AccountType"
          [disabled]="isProcessing"
          [ngModel]="selectedAccountType"
          (ngModelChange)="onAccountTypeChanged($event)"
        >
          <ng-container *ngFor="let type of accountTypes">
            <option [ngValue]="type.value">
              {{ type.name }}
            </option>
          </ng-container>
        </select>
      </div>

      <div class="flex-grow-1 select-field w-full">
        <label class="required" [class.text-hint]="selectedAccountType !== 0"
          >Check Type</label
        >
        <select
          required
          name="CheckType"
          [disabled]="isProcessing || selectedAccountType !== 0"
          [class.invalid]="
            CheckType.invalid && isSubmitted && selectedCheckType === ''
          "
          [ngModel]="selectedCheckType"
          (ngModelChange)="onCheckTypeChanged($event)"
          #CheckType="ngModel"
        >
          <ng-container *ngFor="let type of checkTypes">
            <option [ngValue]="type.value">
              {{ type.name }}
            </option>
          </ng-container>
        </select>
      </div>
    </div>

    <button
      cjButton
      type="button"
      class="!bg-blue-10 !text-blue-90 !border-blue-10 self-start"
      [disabled]="isProcessing"
      (click)="onAddACH()"
    >
      {{ !isAddACH ? "Pay via new ACH" : "Select ACH Details" }}
    </button>

    <cj-form-field *ngIf="isAddACH">
      <cj-form-label>Check Holder Name</cj-form-label>
      <input
        cjInput
        fullWidth
        required
        type="text"
        name="CheckHolderName"
        [disabled]="isProcessing"
        [status]="CheckHolderName.invalid && isSubmitted ? 'danger' : ''"
        [ngModel]="achPayment.CheckHolderName"
        (ngModelChange)="onChange('CheckHolderName', $event)"
        #CheckHolderName="ngModel"
      />
    </cj-form-field>

    <cj-form-field class="flex-grow-1 w-full">
      <cj-form-label>Amount Due</cj-form-label>
      <input
        cjInput
        fullWidth
        readonly
        [value]="invoiceBalance | currency"
        [disabled]="isProcessing"
      />
    </cj-form-field>
  </div>
</form>
